import { render, staticRenderFns } from "./maladie.vue?vue&type=template&id=70ba8f8a&scoped=true"
import script from "./maladie.vue?vue&type=script&lang=js"
export * from "./maladie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba8f8a",
  null
  
)

export default component.exports